import { useContext } from "react";
import { SlotCardProps } from "./types";
import { Typography } from "@mui/material";
import { SlotCardStyled } from "./slot-card.styles";
import { formatTimeSlot } from "../../../../utils/common-utils";
import {
  USER_APPOINTMENT_ACTIONS,
  UserAppointmentContext,
} from "../../context/user-appointment-context";

const SlotCard: React.FC<SlotCardProps> = ({ slot }) => {
  const {
    state: { selectedTimeSlot },
    userDispatcher,
  } = useContext(UserAppointmentContext);

  const handleClick = () => {
    userDispatcher({
      type: USER_APPOINTMENT_ACTIONS.SET_SELECTED_TIME_SLOT,
      payload: {
        start: slot.block.start,
        end: slot.block.end,
      },
    });
  };
  const selected =
    selectedTimeSlot?.start === slot.block.start &&
    selectedTimeSlot?.end === slot.block.end;

  return (
    <SlotCardStyled
      className={`${selected ? "selected" : ""}`}
      onClick={handleClick}
    >
      <Typography className="date-range">
        {formatTimeSlot(slot.block.start, slot.block.end)}
      </Typography>
    </SlotCardStyled>
  );
};

export default SlotCard;
